module.exports = __webpack_public_path__ + "img/upgrade-sub.cf7f0763.svg";